import { render, staticRenderFns } from "./FormConfigurationContainer.vue?vue&type=template&id=817a4994"
import script from "./FormConfigurationContainer.vue?vue&type=script&lang=js"
export * from "./FormConfigurationContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports